import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { showModal } from '../../../features/modal/ducks';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import config from '../../../config';
import { allocationActions, settingKeys } from '../../../common/enums';
import { apiCallIds } from '../api';
import { AllocationList, NoAllocations } from '../components';
import { selectAllocations, fetchAllocationsActions, deleteAllocationActions, setCreditorAllocationsFilterAction, selectCreditorAllocationsFilter, selectTotalAllocationsCount, selectFilteredAllocationsCount } from '../ducks';
import Button from 'antd/lib/button';
import { OpenFileLink } from '../../../common/components/data-display';
import { selectToken, selectAccount, selectAccountInterests } from '../../../features/auth/ducks';
import Modal from 'antd/lib/modal';
import DatePicker from 'antd/lib/date-picker';
import { Spin } from 'antd';
import { selectSettingNumeric } from '../../settings/ducks';

const activeActions = [allocationActions.SIGN_CONTRACT, allocationActions.ENTER_SMS_CODE_CONTRACT];

const mapStateToProps = state => ({
  allocations: selectAllocations(state),
  isFetching: selectIsInProgress(state, apiCallIds.FETCH_ALLOCATIONS),
  token: selectToken(state),
  account: selectAccount(state),
  filter: selectCreditorAllocationsFilter(state),
  total: selectTotalAllocationsCount(state),
  count: selectFilteredAllocationsCount(state),
  minMonths: selectSettingNumeric(state, settingKeys.LOAN_MIN_MONTHS),
  maxMonths: selectSettingNumeric(state, settingKeys.LOAN_MAX_MONTHS),
  interestRange: selectAccountInterests(state),

});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchAllocations: fetchAllocationsActions.request,
      deleteAllocation: deleteAllocationActions.request,
      setFilter: setCreditorAllocationsFilterAction,
      showSignAllocationModal: allocation =>
        showModal({ id: apiCallIds.SIGN_ALLOCATION, data: allocation }),
      showConfirmAllocationModal: allocationId =>
        showModal({ id: apiCallIds.CONFIRM_ALLOCATION, data: allocationId }),
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class AllocationsContainer extends Component {
  static propTypes = {
    allocations: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired,
    isFetching: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { currentPage: 0, visible: false, dateFrom: "", dateTo: "" };
    this.nextButtonHandle = this.nextButtonHandle.bind(this);
    this.previousButtonHandle = this.previousButtonHandle.bind(this);
  }

  componentDidMount() {
    this.props.actions.fetchAllocations({
      ...this.props.filter,
      pageSize: 20,
      pageNo: this.state.currentPage
    });
    document.documentElement.scrollTop = 0;
  }

  nextButtonHandle() {
    this.setState((state, props) => ({
      currentPage: state.currentPage + 1
    }));

    this.props.actions.fetchAllocations({
      ...this.props.filter,
      pageSize: 20,
      pageNo: this.state.currentPage + 1
    });
    document.documentElement.scrollTop = 0;
  }

  previousButtonHandle() {
    this.setState((state, props) => ({
      currentPage: state.currentPage - 1
    }));

    this.props.actions.fetchAllocations({
      ...this.props.filter,
      pageSize: 20,
      pageNo: this.state.currentPage - 1
    });
    document.documentElement.scrollTop = 0;
  }

  onFilterChange = (value, key) => {
    const { filter, actions } = this.props;
    
    actions.setFilter({
      ...filter,
      [key]: value,
    });
  }

  onToggleFilter = () => {
    const { actions } = this.props

    actions.setFilter({
      status: '',
      type: '',
      createdAt: [],
      interest: [],
      months: []
    })
  }
    
  render() {
    const { allocations, actions, isFetching, filter, total, count, minMonths, maxMonths , interestRange ,token } = this.props;

    let interestsArray = interestRange.map(x => Number(x.allocationInterestMax))
    const interestMin = Math.min(...interestsArray)
    const interestMax = Math.max(...interestsArray)

    if (allocations.length === 0) {
      return <NoAllocations 
        filter={filter} 
        onTurnFilterOff={this.onToggleFilter}
        onChange={this.onFilterChange}
        total={total}
        count={count}
        minMonths={minMonths}
        maxMonths={maxMonths}
        interestMin={interestMin}
        interestMax={interestMax}
        />;
    }

    let buttons;

    if (this.state.currentPage > 0) {
      if (allocations.length < 20) {
        buttons = <div style={{ marginTop:10 }}>
          <Button size="small" type="primary" onClick={this.previousButtonHandle}>
            Predchádzajúce investície
         </Button>
        </div>;
      } else {
        buttons = <div style={{ marginTop: 10 }}>
        <Button size="small" type="primary" onClick={this.previousButtonHandle}>
          Predchádzajúce investície
         </Button>
        <Button size="small" style={{ float: 'right' }} type="primary" onClick={this.nextButtonHandle}>
          Ďalšie investície
        </Button>
        </div>;
      }
    } else {
      if (allocations.length < 20) {
        buttons = <div></div>;
      } else {
        buttons = <div style={{ marginTop: 10 }}>
          <Button size="small" style={{ float: 'right' }} type="primary" onClick={this.nextButtonHandle}>
            Ďalšie investície
         </Button>
        </div>;
      }
    }

    const pendingActions = allocations.filter(allocation =>
      activeActions.includes(allocation.action)
    ).length;

    return (
      <div>
        <Spin spinning={isFetching}>
          <AllocationList
            filter={filter}
            onChange={this.onFilterChange}
            isFetching={isFetching}
            pendingActions={pendingActions}
            items={allocations}
            showSignAllocationModal={actions.showSignAllocationModal}
            showConfirmAllocationModal={actions.showConfirmAllocationModal}
            deleteAllocation={actions.deleteAllocation}
            onTurnFilterOff={this.onToggleFilter}
            total={total}
            count={count}
            minMonths={minMonths}
            maxMonths={maxMonths}
            interestMin={interestMin}
            interestMax={interestMax}
          />
        
          {buttons}
        </Spin>
        
        
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/allocations/containers/AllocationsContainer.js